// extracted by mini-css-extract-plugin
module.exports = {"container":"_1-Ld7w","small":"_1oEROK","large":"_3WfufZ"};